import axiosInstance from "@/config/axios";
import type { MutateNews } from "@/modules/news/types";

const getNews = async (params?: { [key: string]: string | number }) => {
	const response = await axiosInstance.get("/Admins", { params });
	return response.data;
};

const getNew = async (id: string) => {
	const response = await axiosInstance.get(`/Admins/${id}`);
	return response.data;
};

const createNew = async (data: MutateNews) => {
	console.log(data, "Create Admin");

	// const response = await axiosInstance.post("/Admins", Admin);
	// return response.data;
};

const updateNew = async (id: string | undefined, data: MutateNews) => {
	console.log(id, data, "Update Admin");
	// const response = await axiosInstance.patch(`/Admins/${id}`, data);
	// return response.data;
};

const deleteNew = async (id: string) => {
	console.log(id, "Delete Admin");
	// const response = await axiosInstance.delete(`/Admins/${id}`);
	// return response.data;
};

export { getNews, getNew, createNew, updateNew, deleteNew };
